import React from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

const ManageBranches = () => {
    const { name } = useParams()
    return (
        <div>
            <div className="page-title">
                <h3>Branches</h3>
            </div>
            <div className="manage-branches-menu">
                <NavLink to={`/b/manage/${name}/branches`}>Branches</NavLink>
                <NavLink to={`/b/manage/${name}/branches/sent-requests`}>Sent Requests</NavLink>
                <NavLink to={`/b/manage/${name}/branches/received-requests`}>Received Requests</NavLink>
                <NavLink to={`/b/manage/${name}/branches/suggesteds`}>Suggested</NavLink>
            </div>
            <Outlet />
        </div>
    )
}

export default ManageBranches